import { defineComponent as _defineComponent } from 'vue'
import Icon from "@/components/widgets/icons/Icon.vue"


export default /*#__PURE__*/_defineComponent({
  __name: 'Completed',
  setup(__props) {

const onClose = () => {
  localStorage.clear()
  window.location.href = "/"
}

return { __sfc: true,onClose, Icon }
}

})